import { useUserRoleStore } from "../../stores/userRoleStore";
import { isActionAllowedInArea } from "../useProtectedRoute/utils";
import { Action, Area } from "../useRolePermission/types";

export type HookResult = {
  loading: boolean;
  allowed: boolean | null;
};

const useActionAllowedInArea = (area: Area, action: Action): HookResult => {
  const { roles, loading } = useUserRoleStore();

  if (loading) {
    return {
      loading,
      allowed: null,
    };
  }

  if (!roles.length) {
    return {
      loading: false,
      allowed: false,
    };
  }

  return {
    loading: false,
    allowed: isActionAllowedInArea(area, action, roles),
  };
};

export default useActionAllowedInArea;
